export const initHeader = () => {
  const mobileMenuToggle =
    document.getElementsByClassName('mobile-menu-toggle');
  if (!mobileMenuToggle?.length) {
    return;
  }

  const mobileMenu = document.querySelectorAll('.menu-mobile-menu-container');

  mobileMenuToggle[0].addEventListener('click', () => {
    mobileMenuToggle[0].classList.toggle('close');
    mobileMenu.forEach((element) => {
      element.classList.toggle('open');
      document.documentElement.classList.toggle('no-scroll');
    });
  });

  const subMenuToggle = document.querySelectorAll(
    '.menu-mobile-menu-container .menu-item-has-children a',
  );
  subMenuToggle.forEach((toggle) => {
    toggle.addEventListener('click', () => {
      const parent = toggle.closest('.menu-item-has-children');
      const submenu = parent.querySelector(':scope > ul');

      if (!submenu) {
        return;
      }

      // Toggle active class for styling
      parent.classList.toggle('sub-menu-open');

      if (submenu.style.maxHeight) {
        // If already open, close it
        submenu.style.maxHeight = null;
      } else {
        submenu.style.maxHeight = `${submenu.scrollHeight}px`;
      }
    });
  });

  const mainHeader = document.querySelector('#main-header');
  const headerNav = document.querySelectorAll('#main-header .nav li a');
  const headerNavLi = document.querySelectorAll('#main-header .nav li');
  const logoScroll = document.querySelector('#main-header img');
  const residentPortal = document.querySelector(
    '#main-header .nav .investor-portal a',
  );

  const search = document.querySelector('#et_search_icon');
  const searchInput = document.querySelector(' .et-search-form input');
  const closeSearch = document.querySelector('.et_close_search_field');
  const closeBar = document.querySelectorAll('.mobile-menu-toggle .bar');
  const getStarted = document.querySelector('.get-started');

  const mobileItemsContainer = document.querySelector(
    '.mobile-menu-items-container',
  );

  window.addEventListener('scroll', () => {
    const scroll = window.scrollY;
    if (scroll > 0) {
      mainHeader.classList.remove('et-fixed-header');
      mainHeader.classList.add('header-white');
      residentPortal.classList.add('key-dark');
      logoScroll.src =
        '/wp-content/themes/mlgcapital-divi-child/assets/svg/mlg-logo-dark.svg';
      search.classList.add('search-dark');
      searchInput.classList.add('input-scroll');
      closeSearch.classList.add('close-search-scroll');
      getStarted.classList.add('get-started-scroll');
      for (let i = 0; i < headerNav.length; i++) {
        headerNav[i].classList.add('nav-black');
        headerNav[i].classList.add('menu-arrow-black');
      }

      for (let i = 0; i < headerNavLi.length; i++) {
        headerNavLi[i].classList.add('scroll-has-children');
      }

      for (let i = 0; i < closeBar.length; i++) {
        closeBar[i].style.background = '#000';
      }
    } else {
      mainHeader.classList.remove('header-white');
      residentPortal.classList.remove('key-dark');
      logoScroll.src =
        '/wp-content/themes/mlgcapital-divi-child/assets/svg/main-logo.svg';
      search.classList.remove('search-dark');
      searchInput.classList.remove('input-scroll');
      closeSearch.classList.remove('close-search-scroll');
      getStarted.classList.remove('get-started-scroll');
      for (let i = 0; i < headerNav.length; i++) {
        headerNav[i].classList.remove('nav-black');
        headerNav[i].classList.remove('menu-arrow-black');
      }

      for (let i = 0; i < headerNavLi.length; i++) {
        headerNavLi[i].classList.remove('scroll-has-children');
      }

      for (let i = 0; i < closeBar.length; i++) {
        closeBar[i].style.background = '#fff';
      }
    }
  });
  const linkNoText = document.querySelectorAll(
    '.mobile-menu .link-text a:first-child',
  );

  for (let i = 0; i < linkNoText.length; i++) {
    linkNoText[i].style.display = 'none';
  }

  const acfMenuDesc = document.querySelectorAll(
    '.mobile-menu .link-text .acf-menu-desc a:first-child',
  );

  for (let i = 0; i < acfMenuDesc.length; i++) {
    acfMenuDesc[i].style.display = 'block';
  }

  function updateHeaderStyles() {
    const scroll = window.scrollY;
    if (scroll === 0) {
      headerNav.forEach((item) => {
        item.style.color = '#000';
        item.classList.add('menu-arrow-black');
      });
      logoScroll.src =
        '/wp-content/themes/mlgcapital-divi-child/assets/svg/mlg-logo-dark.svg';
      residentPortal.classList.add('key-dark');
      search.classList.add('search-dark');
      for (let i = 0; i < closeBar.length; i++) {
        closeBar[i].style.background = '#000';
      }
    } else {
      headerNav.forEach((item) => {
        item.style.color = ''; // or original color
        item.classList.add('menu-arrow-black');
      });
    }
    mobileItemsContainer.classList.add('dark-items');
  }

  // Only run if body has 'single or search-results' class
  if (
    document.body.classList.contains('single-post') ||
    document.body.classList.contains('search-results') ||
    document.body.classList.contains('single-news_events') ||
    document.body.classList.contains('single-teams') ||
    window.location.href.includes('welcome') ||
    document.querySelector('.et_password_protected_form') ||
    document.querySelector('.white-bg') ||
    (document.querySelector('.white-bg') &&
      document.querySelector('.blog-share-icons')) ||
    !document.body.classList.contains('et_pb_pagebuilder_layout')
  ) {
    document.body.classList.add('header-white');
    updateHeaderStyles(); // Run on page load
    window.addEventListener('scroll', updateHeaderStyles); // Run on scroll

    const mobileMenuPost = document.querySelectorAll('.mobile-menu');

    mobileMenuToggle[0].addEventListener('click', () => {
      mobileMenuToggle[0].classList.toggle('post');
      search.classList.toggle('search-dark');

      // Toggle between the two logos
      if (
        logoScroll.src.includes(
          '/wp-content/themes/mlgcapital-divi-child/assets/svg/main-logo.svg',
        )
      ) {
        logoScroll.src =
          '/wp-content/themes/mlgcapital-divi-child/assets/svg/mlg-logo-dark.svg';
      } else {
        logoScroll.src =
          '/wp-content/themes/mlgcapital-divi-child/assets/svg/main-logo.svg';
      }

      mobileMenuPost.forEach((element) => {
        element.classList.toggle('open');
      });
    });
  }

  window.dispatchEvent(new Event('scroll'));
};
